const ErrorFallback = () => (
  <div>
    <h1>Something went wrong!</h1>
    <p>Please try again later or contact support@invozio.com.</p>
  </div>
);

export default ErrorFallback;
